import React from 'react';
import { Handle, Position } from 'reactflow';
import { Play } from 'lucide-react';
import './NodeStyles.css';

const StartNode = ({ data, selected }) => {
  const badge = data?.wfBadge; // e.g., { code:'E006', title:'START issue: ...' }
  return (
    <div className={`start-node ${selected ? 'selected' : ''}`} title={data?.wfTooltip}>
      <div className="term-badge">
        <Play size={14} fill="currentColor" />
      </div>
      <span className="term-label">Start</span>
      {badge && (
        <div
          className="wf-badge"
          title={badge.title || badge.code}
          style={{ marginLeft: 8, display: 'inline-block', padding: '2px 6px', borderRadius: 10, border: '1px solid #dc3545', background: '#f8d7da', color: '#333', fontSize: 11 }}
        >
          {badge.code}
        </div>
      )}
      <Handle type="source" position={Position.Bottom} className="node-handle node-handle-bottom" />
    </div>
  );
};

export default StartNode;
